import React from 'react';
import { challenges } from '../data/mock';
import { FileStack, UserX, TrendingDown, Clock } from 'lucide-react';

const iconMap = {
  FileStack,
  UserX,
  TrendingDown,
  Clock,
};

const ChallengesSection = () => {
  return (
    <section className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4">
            <span className="md:hidden">こんな課題を<br />抱えていませんか？</span>
            <span className="hidden md:inline">こんな課題を抱えていませんか？</span>
          </h2>
          <p className="text-slate-600 text-lg max-w-2xl mx-auto">
            SEOコンテンツ制作の現場で、多くのディレクターが直面する課題
          </p>
        </div>

        {/* Challenge Cards */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {challenges.map((challenge, index) => {
            const IconComponent = iconMap[challenge.icon];
            return (
              <div
                key={challenge.id}
                className="group relative bg-slate-50 border border-slate-200 rounded-xl p-6 hover:bg-white hover:border-slate-300 hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                {/* Icon - Changed to cyan */}
                <div className="w-12 h-12 bg-cyan-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-cyan-200 transition-colors">
                  {IconComponent && (
                    <IconComponent className="w-6 h-6 text-cyan-600" />
                  )}
                </div>

                {/* Content */}
                <h3 className="text-slate-900 font-semibold text-lg mb-2">
                  {challenge.title}
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed">
                  {challenge.description}
                </p>

                {/* Hover accent - Changed to cyan */}
                <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-cyan-500 to-teal-500 rounded-b-xl opacity-0 group-hover:opacity-100 transition-opacity" />
              </div>
            );
          })}
        </div>

        {/* Bottom message */}
        <div className="mt-12 text-center">
          <p className="text-slate-700 text-lg">
            <span className="md:hidden">これらの課題を、<br /><span className="text-cyan-600 font-semibold">E-E-A-Tチェッカー</span>は解決します</span>
            <span className="hidden md:inline">これらの課題を、<span className="text-cyan-600 font-semibold">E-E-A-Tチェッカー</span>は解決します</span>
          </p>
        </div>
      </div>
    </section>
  );
};

export default ChallengesSection;